import { useEffect } from 'react';

import { analytics } from '@/lib/analytics/analytics';
import {
  ANALYTICS_EVENT,
} from '@/lib/analytics/types/analytics-enums';
import { useAccountState } from '@/contexts/account/account-context';
import useStore from '@/store/app/use-store';
import type { AnalyticsEventProperties } from '@/lib/analytics/types/analytics-types';

const trackedEventsForPage = new Set<string>();

function getTrackingKey(eventName: string): string {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  return `${pathname}::${eventName}`;
}

export function useTracking(eventName: ANALYTICS_EVENT | string = ANALYTICS_EVENT.PAGE_VIEWED, additionalProperties?: AnalyticsEventProperties) {
  const { accountId, pixelId, currentAccount } = useAccountState();
  const storedUser = useStore(s => s.user);
  const trackingKey = getTrackingKey(eventName);

  useEffect(() => {
    if (trackedEventsForPage.has(trackingKey)) {
      return;
    }
    trackedEventsForPage.add(trackingKey);

    analytics.track(eventName, {
      accountId: accountId,
      pixelId: pixelId,
      email: storedUser?.email,
      accountName: currentAccount?.accountName,
      accountStatus: currentAccount?.accountStatus,
      referrer: typeof document !== 'undefined' ? document.referrer : undefined,
      ...additionalProperties,
    });
  }, [
    trackingKey,
    eventName,
    accountId,
    pixelId,
    storedUser?.email,
    currentAccount?.accountName,
    currentAccount?.accountStatus,
    additionalProperties,
  ]);
}
